<template>
	<div
		:class="['tag-label', taglabelClassName, stateClassName]"
		v-on="$listeners"
	>
		<div class="tag-label__message">
			{{ message }} {{ subMessage ? `(${subMessage})` : '' }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'TagLabel',
	props: {
		title: {
			type: String,
			default: ''
		},
		message: {
			type: String,
			default: ''
		},
		subMessage: {
			type: [String, Number],
			default: ''
		},
		variant: {
			type: String,
			default: 'text',
			validator(value) {
				return ['text', 'hyperlink'].includes(value);
			}
		},
		state: {
			type: String,
			default: '',
			validator(value) {
				return [
					'',
					'positive',
					'negative',
					'warning',
					'neutral',
					'secondary-1',
					'secondary-2',
					'secondary-3',
					'secondary-4'
				].includes(value);
			}
		}
	},
	computed: {
		taglabelClassName() {
			return 'tag-label--' + this.variant;
		},
		stateClassName() {
			return this.state ? 'tag-label--' + this.state : '';
		}
	},
	methods: {
		handleClick(e) {
			this.$emit('click', e);
		}
	}
};
</script>

<style lang="scss" scoped>
/* DEFAULT / TEXT */
.tag-label { 
	display: inline-flex; 
	align-items: center; 
	justify-content: center;
	padding: $padding-xs; 
	background-color: $neutral-2; 
	border: $tag-label-border-width solid $neutral-4;
	border-radius: 
	$tag-label-border-radius; 
	cursor: default; 
	
	&__message {
		font-size: $bd-txt-font-size-sm; 
		text-transform: capitalize; 
		color: $white; 
		line-height: 1; 
	} 
} 

/* HYPERLINK */
.tag-label--hyperlink { 
	cursor: pointer; 
	background-color: $neutral-4; 
	border: $tag-label-border-width solid $neutral-2;
	
	.tag-label__message { 
		color: $neutral-1; 
		border-bottom: 1px solid; 
	} 
	
	&:hover { 
		background-color: $neutral-2; 
		border: $tag-label-border-width solid $neutral-4;
		
		.tag-label__message { 
			color: $white; 
		} 
	} 
} 

/* POSITIVE */
.tag-label--positive { 
	background-color: $ui-positive; 
	border: $tag-label-border-width solid $ui-positive;
	
	.tag-label__message { 
		color: $white; 
	} 
	
	&:hover { 
		background-color: $ui-positive; 
		border: $tag-label-border-width solid $ui-positive;
	} 	
} 

/* NEGATIVE */
.tag-label--negative { 
	background-color: $ui-negative; 
	border: $tag-label-border-width solid $ui-negative;

	.tag-label__message { 
		color: $white; 
	} 
	
	&:hover { 
		background-color: $ui-negative; 
		border: $tag-label-border-width solid $ui-negative;
	} 
}

/* WARNING */
.tag-label--warning {
	background-color: $ui-warning; 
	border: $tag-label-border-width solid $ui-warning;
	
	.tag-label__message { 
		color: $neutral-1; 
	} 
	
	&:hover { 
		background-color: $ui-warning; 
		border: $tag-label-border-width solid $ui-warning;
		
		.tag-label__message { 
			color: $neutral-1;
		}
	} 
} 

/* NEUTRAL */
.tag-label--neutral { 
	background-color: $ui-neutral-light; 
	border: $tag-label-border-width solid $ui-neutral;
	
	.tag-label__message { 
		color: $neutral-1; 
	} 
} 

.tag-label--hyperlink.tag-label--neutral { 
	&:hover { 
		background-color: $ui-neutral; 
		border: $tag-label-border-width solid $ui-neutral-light; 
	} 
} 

/* SECONDARY 1 */
.tag-label--secondary-1 { 
	background-color: $ui-secondary-1-light; 
	border: $tag-label-border-width solid $ui-secondary-1;
	
	.tag-label__message { 
		color: $neutral-1; 
	} 
} 

.tag-label--hyperlink.tag-label--secondary-1 {
	&:hover { 
		background-color: $ui-secondary-1;
		border: $tag-label-border-width solid $ui-secondary-1-light; 
	} 
} 

/* SECONDARY 2 */
.tag-label--secondary-2 { 
	background-color: $ui-secondary-2-light; 
	border: $tag-label-border-width solid $ui-secondary-2;
	
	.tag-label__message { 
		color: $neutral-1; 
	} 
} 

.tag-label--hyperlink.tag-label--secondary-2 {
	&:hover { 
		background-color: $ui-secondary-2; 
		border: $tag-label-border-width solid $ui-secondary-2-light; 
	} 
}
 
 /* SECONDARY 3 */
 .tag-label--secondary-3 { 
	background-color: $ui-secondary-3-light; 
	border: $tag-label-border-width solid $ui-secondary-3;
	
	.tag-label__message { 
		color: $neutral-1; 
	} 
} 

.tag-label--hyperlink.tag-label--secondary-3 { 
	&:hover { 
		background-color: $ui-secondary-3; 
		border: $tag-label-border-width solid $ui-secondary-3-light; 
	} 
} 

/* SECONDARY 4 */
.tag-label--secondary-4 { 
	background-color: $ui-secondary-4-light;
	border: $tag-label-border-width solid $ui-secondary-4; 
	
	.tag-label__message { 
		color: $neutral-1; 
	} 
} 

.tag-label--hyperlink.tag-label--secondary-4 { 
	&:hover { 
		background-color: $ui-secondary-4;
		border: $tag-label-border-width solid $ui-secondary-4-light; 
	} 
} 
</style>
